export default __webpack_public_path__ + "static/media/craon5.5027da4e.jpg";